import { lazy } from 'react';

const FoundersClubSectionLazy = lazy(() => import('../FoundersClubSection'));

export default FoundersClubSectionLazy;
